/**
 * The connection banner's answer, from the CONNECTION alone.
 *
 * A legacy account being brought over on first sign-in holds the socket open
 * at `connecting` for as long as its export takes — that is neither
 * "Connection lost — reconnecting…" nor "Syncing your changes…"; the seed
 * surface (`account-seed.ts`) tells it. The seed used to read as a sync
 * `error`, which this mapped to `reconnecting`: a false "connection lost"
 * banner over a perfectly healthy socket.
 */
import { type AccountSeedState, isAccountSeedPending } from './account-seed';
import type { SyncStatus } from './internal/hook/sync-context-types';

export type ConnectionState = 'online' | 'offline' | 'syncing' | 'reconnecting';

export function connectionStateOf(
  isOnline: boolean,
  syncStatus: SyncStatus,
  seed: AccountSeedState,
): ConnectionState {
  if (!isOnline) return 'offline';
  if (syncStatus === 'disconnected' || syncStatus === 'error') return 'reconnecting';
  if (syncStatus === 'connecting' && isAccountSeedPending(seed)) return 'online';
  if (syncStatus === 'syncing' || syncStatus === 'connecting') return 'syncing';
  return 'online';
}
